import { ofos } from './ofos';
import type { OfoType } from '@/hooks/use-ofo-status';

export function ofoName(ofo: OfoType): string | null {
  const name = ofos[ofo]?.brandName ?? null;

  return name;
}
